import React from 'react';
import { Shield, Users, Settings, Database, Bell, Server } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

const ControlPanel = () => {
  const { user } = useAuth();

  const modules = [
    {
      title: 'User Management',
      icon: Users,
      description: 'Manage user roles, permissions, and access control',
      link: '/admin/users'
    },
    {
      title: 'System Settings',
      icon: Settings,
      description: 'Configure global system settings and preferences',
      link: '/admin/settings'
    },
    {
      title: 'Database Management',
      icon: Database,
      description: 'Monitor and manage database operations',
      link: '/admin/database'
    },
    {
      title: 'Security Center',
      icon: Shield,
      description: 'Security settings, audit logs, and compliance',
      link: '/admin/security'
    },
    {
      title: 'Notifications',
      icon: Bell,
      description: 'Configure system notifications and alerts',
      link: '/admin/notifications'
    },
    {
      title: 'System Health',
      icon: Server,
      description: 'Monitor system performance and health metrics',
      link: '/admin/health'
    }
  ];

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-3xl font-bold text-gray-900">Control Panel</h1>
          <p className="mt-1 text-sm text-gray-500">
            Welcome back, {user?.name} (Super Admin)
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {modules.map((module) => {
          const Icon = module.icon;
          return (
            <div
              key={module.title}
              className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow"
            >
              <div className="flex items-center space-x-4">
                <div className="flex-shrink-0">
                  <div className="p-3 bg-blue-100 rounded-lg">
                    <Icon className="h-6 w-6 text-blue-600" />
                  </div>
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-gray-900">{module.title}</h3>
                  <p className="mt-1 text-sm text-gray-500">{module.description}</p>
                </div>
              </div>
              <div className="mt-4">
                <button
                  onClick={() => alert('Module functionality coming soon!')}
                  className="text-sm text-blue-600 hover:text-blue-700 font-medium"
                >
                  Manage →
                </button>
              </div>
            </div>
          );
        })}
      </div>

      <div className="bg-white p-6 rounded-lg shadow-md">
        <h2 className="text-xl font-semibold mb-4">System Status</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="p-4 bg-green-50 rounded-lg">
            <div className="flex items-center">
              <div className="w-2 h-2 bg-green-500 rounded-full mr-2"></div>
              <span className="text-green-700 font-medium">All Systems Operational</span>
            </div>
          </div>
          <div className="p-4 bg-blue-50 rounded-lg">
            <div className="flex items-center">
              <div className="w-2 h-2 bg-blue-500 rounded-full mr-2"></div>
              <span className="text-blue-700 font-medium">Database: Connected</span>
            </div>
          </div>
          <div className="p-4 bg-purple-50 rounded-lg">
            <div className="flex items-center">
              <div className="w-2 h-2 bg-purple-500 rounded-full mr-2"></div>
              <span className="text-purple-700 font-medium">API: Healthy</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ControlPanel;